<script>
import Icon from './Icon.vue';
export default {
    name: "SearchBar",
    components: {
        Icon,
    },
    props: {

    },
    data() {
        return {
            searchQuery: '',
        }
    },
    methods: {
        handleSearch(value) {
            this.$emit('update', value)
        }
    }
}
</script>

<template>
    <div class="ui icon input ag-flex ag-gap-8px align-items-center input-container search-box"
        style="padding: 8px; position: relative">
        <div class="search-input-wrapper">
            <span class="search-icon-inside">
                <Icon icon-name="SearchIcon" />
            </span>
            <input type="text" placeholder="Search here..." v-model="searchQuery"
                @input="handleSearch($event.target.value)" class="input-field-with-icon" />
        </div>
    </div>
</template>

<style scoped>
.search-input-wrapper {
    position: relative;
    width: 100%;
    border-radius: 4px;
    border: 1px solid var(--Slate-200, #E2E8F0);
}

.input-field-with-icon {
    width: 100%;
    padding: 8px 8px 8px 36px;
    border-radius: 4px;
    border: 1px solid var(--Slate-200, #E2E8F0) !important;
    font-size: 1rem;
    box-sizing: border-box;
    background: none !important;
}

.input-field-with-icon:focus-visible {
    border: none !important;
    outline: none !important;
    box-sizing: border-box;
    background: none !important;
}

.search-icon-inside {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    display: flex;
    align-items: center;
    left: 12px;
}

.search-icon {
    width: 20px;
    height: 20px;
    color: #475569;
}

.search-box {
    width: 42%;

}
</style>